import { ProjectInstallationStatusEnum, ProjectInstallationTimelineEnums } from '@api/enum';
import { IProjectInstallation, IProjectInstallationTimeline } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

const dummyData: IProjectInstallationTimeline[] = [
    {
        _id: '6819f42a270a26ea61a2e34a',
        message: 'Client installation updated',
        user: '626a5bd76bd4ab6da24c039b',
        projectTimeLineStatus: ProjectInstallationTimelineEnums.ASSET_PURCHASE_ORDER_CREATED,
        clientInstallation: '1',
        projectInstallation: '9',
        reseller: '61caf1dccb3a8396b119a117',
        createdAt: '2025-05-06T12:00:00.000Z',
        updatedAt: '2025-05-06T12:00:00.000Z',
        createdBy: {
            _id: '626a5bd76bd4ab6da24c039b',
            name: 'Cirhan Khan',
        },
    },
    {
        _id: '6819f42a270a26ea61a2e34b',
        message: 'Project installation updated',
        user: '626a5bd76bd4ab6da24c039c',
        projectTimeLineStatus: ProjectInstallationTimelineEnums.ASSET_PURCHASE_ORDER_UPDATED,
        clientInstallation: '1',
        projectInstallation: '9',
        reseller: '61caf1dccb3a8396b119a117',
        createdAt: '2025-05-06T12:10:00.000Z',
        updatedAt: '2025-05-06T12:10:00.000Z',
        createdBy: {
            _id: '626a5bd76bd4ab6da24c039c',
            name: 'Zoya Bhat',
        },
    },
    {
        _id: '6819f42a270a26ea61a2e34c',
        message: 'Site recce created',
        user: '626a5bd76bd4ab6da24c039d',
        projectTimeLineStatus: ProjectInstallationTimelineEnums.SITE_RECCE_CREATED,
        clientInstallation: '1',
        projectInstallation: '9',
        reseller: '61caf1dccb3a8396b119a117',
        createdAt: '2025-05-06T12:20:00.000Z',
        updatedAt: '2025-05-06T12:20:00.000Z',
        createdBy: {
            _id: '626a5bd76bd4ab6da24c039d',
            name: 'Amaan Lone',
        },
    },
];

export const getAllProjectInstallation = async (clientInstallationId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations`
    );
    // const data = dummyProjectInstallations;
    return data as IProjectInstallation[];
};

export const addProjectInstallation = async (clientInstallationId: string, payload: any) => {
    const { data, status } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations`,
        payload
    );
    return { data, status };
};

export const getProjectInstallationById = async (clientInstallationId: string, projectInstallationId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}`
    );

    return data as IProjectInstallation;
};

export const updateProjectInstallation = async (
    clientInstallationId: string,
    projectInstallationId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}`,
        payload
    );
    return data as IProjectInstallation;
};

export const updateFileProjectInstallation = async (
    clientInstallationId: string,
    projectInstallationId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/files`,
        payload
    );
    return data as IProjectInstallation;
};
export const removeFileProjectInstallation = async (
    clientInstallationId: string,
    projectInstallationId: string,
    fileId: string
) => {
    const { data } = await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/files/${fileId}`
    );
    return data as IProjectInstallation;
};

export const getProjectInstallationTimeline = async (clientInstallationId: string, projectInstallationsId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationsId}/project-timeline`
    );
    // const data = dummyData;
    return data as IProjectInstallationTimeline[];
};
